import { Link } from "react-router-dom";

export default function WELPAR_2026() {
    return (
         <>
            <div className="mt-10 p-5 desktop:p-6 rounded-2xl border border-contact bg-contact-bg">
                <div className="flex flex-col gap-4">
                    <div>
                        <h3 className="text-lg font-bold font-sans">CONTACT US</h3>
                        <p className="text-xs text-white/40 font-sans">Hubungi kami jika kamu memiliki pertanyaan</p>
                    </div>

                    <div className="flex flex-col desktop:flex-row gap-4">
                        <div className="flex-1 flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-bold text-white/90 font-sans">CONTACT PERSON 1</span>
                                <span className="w-px h-4 bg-white/20" />
                                <span className="text-sm text-white/50 font-sans">Amelia Airin</span>
                            </div>
                            <div className="flex gap-2">
                                <a href="https://wa.me/6281388494640" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-7 py-3 rounded-lg bg-whatsapp text-white text-sm font-semibold font-sans 
                                no-underline hover-scale-btn hover-shadow-whatsapp">
                                    <i className="fa-brands fa-whatsapp text-sm" />
                                    WhatsApp
                                </a>
                            </div>
                        </div>

                        <div className="hidden desktop:block w-px bg-divider self-stretch" />

                        <div className="flex-1 flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-bold text-white/90 font-sans">CONTACT PERSON 2</span>
                                <span className="w-px h-4 bg-white/20" />
                                <span className="text-sm text-white/50 font-sans">Theodore Wiryo Pranoto</span>
                            </div>
                            <div className="flex gap-2">
                                <a href="https://wa.me/6282146842900" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-7 py-3 rounded-lg bg-whatsapp text-white text-sm font-semibold font-sans 
                                no-underline hover-scale-btn hover-shadow-whatsapp">
                                    <i className="fa-brands fa-whatsapp text-sm" />
                                    WhatsApp
                                </a>
                            </div>
                        </div>
                    </div>

                    <hr className="border-none border-t border-divider" />

                    {/* Official Channels */}
                    <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
                        <a href="https://www.instagram.com/himstat.spss/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-brands fa-instagram text-base w-5 text-center" />
                            @himstat.spss
                        </a>
                        <a href="https://www.instagram.com/himstat/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-brands fa-instagram text-base w-5 text-center" />
                            @himstat
                        </a>
                        <a href="https://himstat.com/siwu-registration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-solid fa-globe text-base w-5 text-center" />
                            himstat.com
                        </a>
                        <a href="mailto:himstat@gmail.com" className="inline-flex items-center gap-2 text-sm text-white/60 font-sans no-underline hover:text-white/90 transition-colors">
                            <i className="fa-solid fa-envelope text-base w-5 text-center" />
                            himstat@gmail.com
                        </a>
                    </div>
                </div>
            </div>

            <div className="mt-5 p-6 desktop:p-8 rounded-2xl border border-card-border bg-card-bg">
                <h3 className="text-xl font-bold mb-3 font-sans">PENDAFTARAN SIWU 2026</h3>
                <p className="text-sm text-white/50 mb-5 font-sans leading-relaxed">
                    Ikuti SIWU 2026 dan tambahkan relasi dan pengetahuan mu di keluarga HIMSTAT!
                </p>

            <div className="flex items-start gap-3">
                <a 
                    href="https://himstat.com/siwu-registration" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center gap-2 px-7 py-3 rounded-xl bg-white text-midnight text-sm font-bold font-sans no-underline hover-scale-btn hover-shadow-white"
                >
                    Daftar Sekarang
                    <i className="fa-solid fa-arrow-right text-xs" />
                </a>
            </div>
            </div>
        </>
    );
}
